import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import { defineComponent, ref, watch, onMounted, onUnmounted, nextTick } from "vue"; // modules

import POSConfigModule from "@/store/modules/pos-config";
import { PCTypes } from "@/types/db/product-category";
import { getProductCategoriesWithPricesArray, getProductCategoriesWithFlatPrice } from "@/utils/helpers/product-category";
import { recordOperationDuration } from "@/utils/vue-helpers/common";
import { useIntersectionObserver } from "@vueuse/core";
import { LogService } from "@/services/logging";
import { PRODUCT_CATEGORY_PAGINATION_LIMIT } from "@/constants/app";
import { queryTimeslotsByProductCategories } from "@/dexie/timeslots";
export default defineComponent({
  name: "TicketsGrid",
  props: {
    ticketGroupId: {
      type: Number,
      required: true
    }
  },
  components: {},
  setup: function setup(props) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var loading, selectedConfig, keys, groupedProducts, didScroll, productsCount, noMoreProducts, loadTrigger, isLoadingProducts, intersectionObserverCleanup, handleScroll, handleTouchStart, attachTimeslotData, _attachTimeslotData, groupProductsByLetter, loadProducts, _loadProducts, resetState, setupIntersectionObserver;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setupIntersectionObserver = function _setupIntersectionObs() {
                // clean up previous observer if exists
                if (intersectionObserverCleanup) {
                  intersectionObserverCleanup();
                  intersectionObserverCleanup = null;
                } // set up new observer


                var _useIntersectionObser = useIntersectionObserver(loadTrigger, /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
                    var _ref3, isIntersecting, operationStartTime, operationEndTime, operationDuration;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _ref3 = _slicedToArray(_ref, 1), isIntersecting = _ref3[0].isIntersecting;

                            if (!(isIntersecting && !isLoadingProducts.value)) {
                              _context.next = 16;
                              break;
                            }

                            operationStartTime = performance.now();
                            _context.prev = 3;
                            _context.next = 6;
                            return loadProducts();

                          case 6:
                            _context.next = 11;
                            break;

                          case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](3);
                            LogService.info("Error in intersection observer callback", {
                              params: {
                                ticketGroupId: props.ticketGroupId
                              },
                              error: _context.t0
                            });

                          case 11:
                            _context.prev = 11;
                            operationEndTime = performance.now();
                            operationDuration = operationEndTime - operationStartTime;
                            recordOperationDuration("TicketsGrid_refresh for ticketGroupId: ".concat(props.ticketGroupId), operationDuration);
                            return _context.finish(11);

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[3, 8, 11, 16]]);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()),
                    stop = _useIntersectionObser.stop;

                intersectionObserverCleanup = stop;
              };

              resetState = function _resetState() {
                productsCount.value = 0;
                noMoreProducts.value = false;
                isLoadingProducts.value = false;
                keys.value = [];
                groupedProducts.value = {};
              };

              _loadProducts = function _loadProducts3() {
                _loadProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  var newCards, newProductsCount, isSeparatedButtons, t1, _yield$getProductCate, cards, pcCount, duration;

                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!(isLoadingProducts.value || noMoreProducts.value)) {
                            _context4.next = 2;
                            break;
                          }

                          return _context4.abrupt("return");

                        case 2:
                          isLoadingProducts.value = true;
                          _context4.prev = 3;
                          newCards = [];
                          newProductsCount = 0;
                          isSeparatedButtons = POSConfigModule.isSeperatedButtons;
                          t1 = performance.now();

                          if (isSeparatedButtons) {
                            _context4.next = 15;
                            break;
                          }

                          _context4.next = 11;
                          return getProductCategoriesWithPricesArray(props.ticketGroupId, productsCount.value);

                        case 11:
                          newCards = _context4.sent;
                          newProductsCount = newCards.length;
                          _context4.next = 22;
                          break;

                        case 15:
                          _context4.next = 17;
                          return getProductCategoriesWithFlatPrice(props.ticketGroupId, productsCount.value);

                        case 17:
                          _yield$getProductCate = _context4.sent;
                          cards = _yield$getProductCate.cards;
                          pcCount = _yield$getProductCate.pcCount;
                          newCards = cards;
                          newProductsCount = pcCount;

                        case 22:
                          duration = performance.now() - t1;
                          console.log("loadProducts for ticketGroupId: ".concat(props.ticketGroupId, " took ").concat(duration / 1000, " s"));
                          recordOperationDuration("loadProducts for ticketGroupId: ".concat(props.ticketGroupId), duration);

                          if (newProductsCount) {
                            _context4.next = 29;
                            break;
                          }

                          // no new products were fetched
                          noMoreProducts.value = true;
                          isLoadingProducts.value = false;
                          return _context4.abrupt("return");

                        case 29:
                          // Seating plan logic:
                          // from productCards exclude any recurring seating plan since it shouldn't be shown in a alphabetic grid, it should be shown in a calendar
                          newCards = newCards.filter(function (pc) {
                            return !pc.isReccuringSeating;
                          });
                          productsCount.value += newProductsCount;
                          t1 = performance.now();
                          _context4.next = 34;
                          return attachTimeslotData(newCards);

                        case 34:
                          duration = performance.now() - t1;
                          console.log("attachTimeslotData for ticketGroupId: ".concat(props.ticketGroupId, " took ").concat(duration / 1000, " s."));
                          recordOperationDuration("attachTimeslotData for ticketGroupId: ".concat(props.ticketGroupId), duration);
                          t1 = performance.now();
                          groupProductsByLetter(newCards);
                          duration = performance.now() - t1;
                          console.log("groupProductsByLetter for ticketGroupId: ".concat(props.ticketGroupId, " took ").concat(duration / 1000, " s."));
                          recordOperationDuration("groupProductsByLetter for ticketGroupId: ".concat(props.ticketGroupId), duration); // update cards list and the count index

                          if (!newProductsCount || newProductsCount < PRODUCT_CATEGORY_PAGINATION_LIMIT) {
                            // No more products in db
                            // Let's update noMoreProducts to hide the loader element
                            noMoreProducts.value = true;
                          }

                          _context4.next = 48;
                          break;

                        case 45:
                          _context4.prev = 45;
                          _context4.t0 = _context4["catch"](3);
                          LogService.info("Error when fetching products from indexedDB", _context4.t0);

                        case 48:
                          _context4.prev = 48;
                          isLoadingProducts.value = false;
                          return _context4.finish(48);

                        case 51:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, null, [[3, 45, 48, 51]]);
                }));
                return _loadProducts.apply(this, arguments);
              };

              loadProducts = function _loadProducts2() {
                return _loadProducts.apply(this, arguments);
              };

              groupProductsByLetter = function _groupProductsByLette(productCards) {
                if (!productCards || !productCards.length) {
                  return;
                }

                for (var i = 0; i < productCards.length; i++) {
                  var letter = String(productCards[i].categoryName)[0].toUpperCase(); // Check if this letter already has a record in groupedProducts

                  if (groupedProducts.value[letter]) {
                    groupedProducts.value[letter].push(productCards[i]);
                  } else {
                    // This is the first product with this letter
                    groupedProducts.value[letter] = [productCards[i]];
                  }
                }

                keys.value = Object.keys(groupedProducts.value);
              };

              _attachTimeslotData = function _attachTimeslotData3() {
                _attachTimeslotData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(productCards) {
                  var now, PCIds, i, allTimeslots, timeslotsByCategory, _iterator, _step, _timeslot, _i, categoryId, timeslot;

                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(!productCards || !productCards.length)) {
                            _context3.next = 2;
                            break;
                          }

                          return _context3.abrupt("return");

                        case 2:
                          now = new Date().toISOString(); // Collect all product category IDs that need timeslots (non-retail products)

                          PCIds = [];
                          i = 0;

                        case 5:
                          if (!(i < productCards.length)) {
                            _context3.next = 12;
                            break;
                          }

                          if (!(productCards[i].type === PCTypes[PCTypes.Retail] || !productCards[i].productCategoryId)) {
                            _context3.next = 8;
                            break;
                          }

                          return _context3.abrupt("continue", 9);

                        case 8:
                          PCIds.push(Number(productCards[i].productCategoryId));

                        case 9:
                          i++;
                          _context3.next = 5;
                          break;

                        case 12:
                          // Fetch all future timeslots for products
                          allTimeslots = [];

                          if (!(PCIds.length > 0)) {
                            _context3.next = 17;
                            break;
                          }

                          _context3.next = 16;
                          return queryTimeslotsByProductCategories({
                            categoryIds: PCIds,
                            endDateTimeAfter: now
                          });

                        case 16:
                          allTimeslots = _context3.sent;

                        case 17:
                          // Group timeslots by categoryId and take first one per category
                          timeslotsByCategory = new Map();
                          _iterator = _createForOfIteratorHelper(allTimeslots);

                          try {
                            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                              _timeslot = _step.value;

                              if (!timeslotsByCategory.has(_timeslot.categoryId)) {
                                timeslotsByCategory.set(_timeslot.categoryId, _timeslot);
                              }
                            } // Process each product card with its timeslot data

                          } catch (err) {
                            _iterator.e(err);
                          } finally {
                            _iterator.f();
                          }

                          _i = 0;

                        case 21:
                          if (!(_i < productCards.length)) {
                            _context3.next = 30;
                            break;
                          }

                          if (!(productCards[_i].type === PCTypes[PCTypes.Retail])) {
                            _context3.next = 24;
                            break;
                          }

                          return _context3.abrupt("continue", 27);

                        case 24:
                          categoryId = Number(productCards[_i].productCategoryId);
                          timeslot = timeslotsByCategory.get(categoryId);

                          if (timeslot) {
                            productCards[_i].startDateTime = timeslot.startDateTime;
                            productCards[_i].endDateTime = timeslot.endDateTime;
                            productCards[_i].timeslot_ID = timeslot._id;
                            productCards[_i].booked = timeslot.booked; // In case of a non-reccuring seating plan we are taking dbAvailability from childrenPSC.resource.quantity, and it seems this field actually has the total quantity
                            // we need to substract what was already booked from it which we can get from timeslots[0].booked
                            // TODO Hamza: One Concept to Discuss with the Team:
                            // a. Non Reccuring Seating Quantity resides in childPSC.resource.quantity
                            // b. Already booked seats number resides in timeslots[0].booked
                            // c. Now we are deducting what was already booked from total quantity, but the user is still able to go to seats io and make seats available for sales, in this case POS will not know this, how we should handle this case? And did we actually have users who went to seats io and made sold seats available again?

                            if (productCards[_i].type === PCTypes[PCTypes.Seated] && !productCards[_i].isReccuringSeating) {
                              productCards[_i].dbAvailability = Number(productCards[_i].dbAvailability || 0) - timeslot.booked;
                            } else {
                              productCards[_i].dbAvailability = timeslot.availability;
                            }
                          }

                        case 27:
                          _i++;
                          _context3.next = 21;
                          break;

                        case 30:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
                return _attachTimeslotData.apply(this, arguments);
              };

              attachTimeslotData = function _attachTimeslotData2(_x) {
                return _attachTimeslotData.apply(this, arguments);
              };

              handleTouchStart = function _handleTouchStart(e) {
                didScroll.value = false;
              };

              handleScroll = function _handleScroll(e) {
                didScroll.value = true;
              };

              loading = ref(false);
              selectedConfig = ref(POSConfigModule.selectedConfig); //  keys are the alphabets the user sees grouping the ProductCategories

              keys = ref(); // initiating a the variable with an empty object, cast it to be Record type, and make it reactive

              groupedProducts = ref({});
              didScroll = ref(false); // used for pagination when fetching PCs from indexedDB

              productsCount = ref(0);
              noMoreProducts = ref(false);
              loadTrigger = ref();
              isLoadingProducts = ref(false);
              intersectionObserverCleanup = null;
              // watch for ticketGroupId changes and reset/reload
              watch(function () {
                return props.ticketGroupId;
              }, /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(newId, oldId) {
                  var operationStartTime, operationEndTime, operationDuration;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(newId && newId !== oldId)) {
                            _context2.next = 20;
                            break;
                          }

                          resetState();
                          setupIntersectionObserver(); // force initial load after state reset

                          _context2.next = 5;
                          return nextTick();

                        case 5:
                          if (!(!isLoadingProducts.value && !noMoreProducts.value)) {
                            _context2.next = 20;
                            break;
                          }

                          operationStartTime = performance.now();
                          _context2.prev = 7;
                          _context2.next = 10;
                          return loadProducts();

                        case 10:
                          _context2.next = 15;
                          break;

                        case 12:
                          _context2.prev = 12;
                          _context2.t0 = _context2["catch"](7);
                          LogService.info("TicketsGrid: Error during initial load", {
                            params: {
                              ticketGroupId: props.ticketGroupId
                            },
                            error: _context2.t0
                          });

                        case 15:
                          _context2.prev = 15;
                          operationEndTime = performance.now();
                          operationDuration = operationEndTime - operationStartTime;
                          recordOperationDuration("TicketsGrid initial_load for ticketGroupId: ".concat(props.ticketGroupId), operationDuration);
                          return _context2.finish(15);

                        case 20:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[7, 12, 15, 20]]);
                }));

                return function (_x3, _x4) {
                  return _ref4.apply(this, arguments);
                };
              }(), {
                immediate: true
              });
              onMounted(function () {
                setupIntersectionObserver();
              });
              onUnmounted(function () {
                if (intersectionObserverCleanup) {
                  intersectionObserverCleanup();
                }
              });
              return _context5.abrupt("return", {
                selectedConfig: selectedConfig,
                loading: loading,
                keys: keys,
                groupedProducts: groupedProducts,
                attachTimeslotData: attachTimeslotData,
                groupProductsByLetter: groupProductsByLetter,
                // sumArray,
                getProductCategoriesWithPricesArray: getProductCategoriesWithPricesArray,
                getProductCategoriesWithFlatPrice: getProductCategoriesWithFlatPrice,
                didScroll: didScroll,
                handleScroll: handleScroll,
                handleTouchStart: handleTouchStart,
                loadProducts: loadProducts,
                loadTrigger: loadTrigger,
                isLoadingProducts: isLoadingProducts,
                noMoreProducts: noMoreProducts
              });

            case 23:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
});